/**
 * Google Ads Conversion Tracking — BODYMAX
 *
 * Base tag + consent defaults + config are in index.html (required by Google's verifier).
 * This module handles:
 * - Purchase conversion events (idempotent, deduped)
 * - Consent updates when user accepts/declines cookies
 */

const GOOGLE_ADS_ID = 'AW-18425454523';
const PURCHASE_LABEL = '398ACN36ne0cELu_-NFE';
const DEDUP_PREFIX = 'bm_gads_cv_';

function hasConsent() {
  try {
    return localStorage.getItem('bodymax_cookie_consent') === 'accepted';
  } catch {
    return false;
  }
}

function isAlreadyTracked(transactionId) {
  try {
    return localStorage.getItem(`${DEDUP_PREFIX}${transactionId}`) === '1';
  } catch {
    return false;
  }
}

function markTracked(transactionId) {
  try {
    localStorage.setItem(`${DEDUP_PREFIX}${transactionId}`, '1');
  } catch {
    // Storage full or unavailable — non-critical
  }
}

/**
 * Fire the Google Ads Purchase conversion exactly once per transaction.
 *
 * @param {string} transactionId - Stripe Checkout session ID (unique per purchase)
 * @param {number} [value]       - Purchase amount (e.g. 9.99)
 * @param {string} [currency]    - ISO currency code (e.g. 'usd')
 */
export function trackPurchaseConversion(transactionId, value, currency) {
  try {
    if (!transactionId) return;
    if (isAlreadyTracked(transactionId)) return;
    if (!hasConsent()) return;
    if (typeof window.gtag !== 'function') return;

    const eventParams = {
      send_to: `${GOOGLE_ADS_ID}/${PURCHASE_LABEL}`,
      transaction_id: transactionId,
    };

    if (value && value > 0 && currency) {
      eventParams.value = value;
      eventParams.currency = currency.toUpperCase();
    }

    window.gtag('event', 'conversion', eventParams);
    markTracked(transactionId);
  } catch {
    // Tracking must never break the purchase flow
  }
}

/**
 * Update consent state after user accepts/declines cookies.
 * Called from CookieConsent component.
 */
export function updateGoogleAdsConsent(granted) {
  try {
    if (typeof window.gtag !== 'function') return;

    const state = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
      analytics_storage: state,
    });
  } catch {
    // Non-critical
  }
}
